(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amb-launch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amb-launch')) {
    customElements.define('amb-launch', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const video = this.querySelector('video');
        const button = this.querySelector('.amb-launch__motion');
        if (!video || !button) return;
        let manuallyPaused = false;
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.autoplay = true;
        const update = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
        const ready = () => {
          if (!video.paused && video.readyState >= 2) this.setAttribute('data-video-ready', '');
          update();
        };
        const play = () => {
          if (manuallyPaused || document.visibilityState === 'hidden') return;
          video.muted = true;
          video.play().then(ready).catch(update);
        };
        button.hidden = false;
        video.addEventListener('playing', ready, { signal });
        video.addEventListener('pause', update, { signal });
        video.addEventListener('loadeddata', play, { signal });
        video.addEventListener('canplay', play, { signal });
        video.addEventListener('error', () => { this.removeAttribute('data-video-ready'); button.hidden = true; }, { signal });
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') play(); }, { signal });
        window.addEventListener('pageshow', play, { signal });
        button.addEventListener('click', () => {
          if (video.paused) {
            manuallyPaused = false;
            play();
          } else {
            manuallyPaused = true;
            video.pause();
          }
        }, { signal });
        play();
        ready();
      }
      disconnectedCallback() { this.abort?.abort(); this.querySelector('video')?.pause(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
